// @flow
import { Record } from 'immutable';
import { UPDATE_SPOT_SCHEDULE_TIMESLOT_SUCCESS,
         UPDATE_SPOT_SCHEDULE_TIMESLOT_FAILED,
         ADD_SPOT_SCHEDULE_TIMESLOT_SUCCESS,
         ADD_SPOT_SCHEDULE_TIMESLOT_FAILED,
         REMOVE_SPOT_SCHEDULE_TIMESLOT,
         FETCH_SPOT_SCHEDULE,
         FETCH_SPOT_SCHEDULE_SUCCESS,
         FETCH_SPOT_SCHEDULE_FAILED,
         UPDATE_SPOT_SCHEDULE,
         UPDATE_SPOT_SCHEDULE_SUCCESS,
         UPDATE_SPOT_SCHEDULE_FAILED } from '../actions/salesInventoryActions';

export const InitialState = Record({
  spotSchedule: undefined,
  fetching: false,
  error: undefined,
  updating: false,
  updateError: undefined,
  timeSlotModificationError: undefined,
});

export default (state: any = new InitialState(), action: Object) => {
  switch (action.type) {
    case UPDATE_SPOT_SCHEDULE_TIMESLOT_SUCCESS: // same behaviour
    case ADD_SPOT_SCHEDULE_TIMESLOT_SUCCESS:
      return state.set('spotSchedule', action.spotSchedule)
                  .set('timeSlotModificationError', undefined);
    case ADD_SPOT_SCHEDULE_TIMESLOT_FAILED: // same behaviour
    case UPDATE_SPOT_SCHEDULE_TIMESLOT_FAILED:
      return state.set('timeSlotModificationError', action.error);
    case REMOVE_SPOT_SCHEDULE_TIMESLOT:
      return state.set('spotSchedule', action.spotSchedule);
    case FETCH_SPOT_SCHEDULE:
      return state.set('fetching', true)
                  .set('spotSchedule', undefined)
                  .set('error', undefined);
    case FETCH_SPOT_SCHEDULE_SUCCESS:
      return state.set('fetching', false)
                  .set('spotSchedule', action.spotSchedule);
    case FETCH_SPOT_SCHEDULE_FAILED:
      return state.set('fetching', false)
                  .set('error', action.error);
    case UPDATE_SPOT_SCHEDULE:
      return state.set('updating', true)
                  .set('updateError', undefined);
    case UPDATE_SPOT_SCHEDULE_SUCCESS:
      return state.set('updating', false);
    case UPDATE_SPOT_SCHEDULE_FAILED:
      return state.set('updating', false)
                  .set('updateError', action.error);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesInventory/reducers/salesInventoryReducer.js